import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import waseminari from "../assets/waseminari.png";
import visigalogo from "../assets/visigalogo.png";
import basketball from "../assets/basketball.png";
import football from "../assets/football.png";
import basketball1 from "../assets/basketball1.png";
import basketball3 from "../assets/basketball3.png";
import ball from "../assets/ball.png";
import hailmary3 from "../assets/hailmary3.png";

const imageSlides = [football, basketball, basketball1, basketball3];

const Games = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [animate, setAnimate] = useState(false);
  const { t } = useTranslation();

  useEffect(() => {
    const interval = setInterval(() => {
      setAnimate(true);
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % imageSlides.length);
        setAnimate(false);
      }, 1000);
    }, 4000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 px-4 lg:px-10 mt-0 dark:bg-gray-800">
      {/* First Portion */}
      <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
        <h1 className="text-3xl sm:text-xl lg:text-2xl text-center font-bold tracking-wide text-gray-900 dark:text-white mb-6">
          {t("alevel.schoolName")}{" "}
          <span className="bg-gradient-to-r from-blue-500 to-red-800 text-transparent bg-clip-text block mt-2">
            {t("alevel.schoolSub")}
          </span>
        </h1>
        <img
          src={visigalogo}
          alt="Visiga Seminary Logo"
          className="mt-4 w-40 h-auto rounded-full border-4 border-white dark:border-gray-700 shadow-md hover:scale-105 transition-transform duration-300"
        />
      </div>

      {/* Middle Portion */}
      <div className="lg:col-span-6 flex flex-col items-center mt-1 lg:mt-5">
        <h1 className="text-3xl sm:text-4xl lg:text-2xl text-center tracking-wide text-neutral-900 dark:text-neutral-100">
          {t("games.title")}
        </h1>

        <p className="mt-4 text-lg text-neutral-900 dark:text-neutral-100 text-justify w-full">
          {t("games.description")}
        </p>

        {/* Image Carousel */}
        <div
          className="overflow-hidden w-full max-w-[100%] sm:max-w-[400px] md:max-w-[600px] aspect-video mt-6 border border-neutral-300 dark:border-neutral-700 rounded-md"
          style={{
            backgroundImage: `url(${ball})`,
            backgroundSize: "cover",
            backgroundPosition: "center"
          }}
        >
          <div
            className={`w-full h-full transition-transform duration-1000 ease-in-out ${animate ? "-translate-x-full" : "translate-x-0"
              }`}
          >
            <img
              src={imageSlides[currentIndex]}
              alt="Game slide"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>

      {/* Third Portion */}
      <div className="lg:col-span-3 bg-gradient-to-b from-gray-100 to-gray-200 dark:from-gray-800 dark:to-gray-900 p-6 flex flex-col items-center rounded-lg shadow-lg">
        <img
          src={hailmary3}
          alt="Hail Mary"
          className="w-full h-auto max-h-96 object-cover rounded-lg border-4 border-white dark:border-gray-700 shadow-md hover:scale-102 transition-transform duration-300"
        />
        <p className="mt-4 text-center text-gray-600 dark:text-gray-300 italic">
          {t("alevel.motherText")}
        </p>
      </div>
    </div>
  );
};

export default Games;
